/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Test_RunInputs */

const en_admin_settings_test_run = /** @type {(inputs: Admin_Settings_Test_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run Test`)
};

/**
* | output |
* | --- |
* | "Run Test" |
*
* @param {Admin_Settings_Test_RunInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_run = /** @type {((inputs?: Admin_Settings_Test_RunInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_RunInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_test_run(inputs)
});
export { admin_settings_test_run as "admin.settings.test.run" }